import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';


const ServiceCategoriesSection = () => {
  const categories = [
    {
      id: 1,
      name: 'Plumbing',
      icon: 'Wrench',
      description: 'Pipe repairs, installations, and maintenance',
      count: 1250,
    },
    {
      id: 2,
      name: 'Electrical',
      icon: 'Zap',
      description: 'Wiring, repairs, and electrical installations',
      count: 980,
    },
    {
      id: 3,
      name: 'Carpentry',
      icon: 'Hammer',
      description: 'Furniture making, repairs, and woodwork',
      count: 850,
    },
    {
      id: 4,
      name: 'Cleaning',
      icon: 'Sparkles',
      description: 'House cleaning, deep cleaning, and maintenance',
      count: 2100,
    },
    {
      id: 5,
      name: 'Babysitting',
      icon: 'Baby',
      description: 'Childcare, nanny services, and supervision',
      count: 650,
    },
    {
      id: 6,
      name: 'Tutoring',
      icon: 'GraduationCap',
      description: 'Academic tutoring and skill development',
      count: 1450,
    },
    {
      id: 7,
      name: 'Driving',
      icon: 'Car',
      description: 'Personal driver, delivery, and transport services',
      count: 780,
    },
    {
      id: 8,
      name: 'Cooking',
      icon: 'ChefHat',
      description: 'Personal chef, catering, and meal preparation',
      count: 520,
    },
    {
      id: 9,
      name: 'Laundry',
      icon: 'Shirt',
      description: 'Washing, ironing, and garment care',
      count: 890,
    },
    {
      id: 10,
      name: 'Errands',
      icon: 'ShoppingBag',
      description: 'Shopping, deliveries, and personal assistance',
      count: 1120,
    },
    {
      id: 11,
      name: 'Tech Support',
      icon: 'Laptop',
      description: 'Computer repair, setup, and IT assistance',
      count: 670,
    },
    {
      id: 12,
      name: 'Beauty Services',
      icon: 'Scissors',
      description: 'Hair, makeup, nails, and grooming',
      count: 940,
    },
    {
      id: 13,
      name: 'Pet Services',
      icon: 'Dog',
      description: 'Pet grooming, walking, and care services',
      count: 320,
    },
  ];

  return (
    <section className="py-8 md:py-10 lg:py-12 bg-[#F9FAFB] relative overflow-hidden">
      {/* Decorative Background */}
      <div className="absolute inset-0">
        <div className="absolute top-10 right-20 w-72 h-72 bg-[#FF6A00]/10 rounded-full blur-3xl" />
        <div className="absolute bottom-10 left-20 w-72 h-72 bg-[#1E73BE]/10 rounded-full blur-3xl" />
      </div>
      
      <div className="relative max-w-[1400px] mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-6 md:mb-8 lg:mb-10">
          <h2 className="text-xl md:text-2xl lg:text-3xl font-heading font-bold text-foreground mb-2 md:mb-3">
            Browse Service Categories
          </h2>
          <p className="text-xs md:text-sm lg:text-base text-muted-foreground max-w-[700px] mx-auto">
            Find skilled professionals across various service categories
          </p>
        </div>

        {/* Grid Layout for All Categories - Icon and Name Only */}
        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-3 md:gap-4 mb-6">
          {categories?.map((category) => (
            <Link
              key={category?.id}
              to="/job-board"
              className="bg-white rounded-lg p-3 shadow-sm hover:shadow-md transition-all duration-300 group/card border border-gray-100 hover:border-[#FF6A00] hover:-translate-y-1 flex flex-col items-center justify-center"
            >
              <div className="w-10 h-10 md:w-20 md:h-20 lg:w-20 lg:h-20 bg-transparent rounded-lg flex items-center justify-center mb-2 group-hover/card:scale-110 transition-all duration-300">
                <Icon name={category?.icon} size={12} color="#FF6A00" className="md:w-[36px] md:h-[36px] lg:w-[36px] lg:h-[36px]" strokeWidth={1.5} />
              </div>
              <h3 className="text-[10px] md:text-xs font-heading font-semibold text-foreground text-center group-hover/card:text-[#FF6A00] transition-colors">
                {category?.name}
              </h3>
            </Link>
          ))}
        </div>

        <div className="text-center mt-6 md:mt-8">
          <Link to="/job-board">
            <Button
              variant="outline"
              size="lg"
              iconName="ArrowRight"
              iconPosition="right"
              className="border-[#FF6A00] text-[#FF6A00] hover:bg-[#FF6A00]/10"
            >
              View All Categories
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServiceCategoriesSection;